import { Skeleton } from "antd";
import Meeting from "../pages/meeting";

const MeetingSkeleton = () => {
    return (
        <div className="maindiv" style={{ flexDirection: 'column', padding: 24 }}>
            <div className='preview' style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '24px' }}>
                {/* Top Banner */}
                <Skeleton.Image style={{ width: '100%', height: 300, borderRadius: 12 }} active />

                {/* Event + Speaker Info */}
                <div className='preview22' style={{ display: 'flex', flexDirection: 'row', gap: 24 }}>
                    <div className='meetingdetails' style={{ flex: 1 }}>
                        <Skeleton.Button active style={{ width: 100, height: 80, marginBottom: 12 }} />
                        <Skeleton.Input active size="large" style={{ width: 250, marginBottom: 12 }} />
                        <Skeleton paragraph={{ rows: 5 }} active />
                    </div>

                    {/* Countdown + Form */}
                    <div className='meetingjoin' style={{ flex: 1 }}>
                        <Skeleton.Input style={{ width: 300, height: 50, marginBottom: 24 }} active />
                        <div style={{ display: 'flex', gap: '12px', marginBottom: 24 }}>
                            <Skeleton.Button style={{ width: 60, height: 60 }} active />
                            <Skeleton.Button style={{ width: 60, height: 60 }} active />
                            <Skeleton.Button style={{ width: 60, height: 60 }} active />
                            <Skeleton.Button style={{ width: 60, height: 60 }} active />
                        </div>
                        <Skeleton.Input style={{ width: '100%', height: 45, marginBottom: 12 }} active />
                        <Skeleton.Input style={{ width: '100%', height: 45, marginBottom: 12 }} active />
                        <Skeleton.Button style={{ width: '100%', height: 45 }} active />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MeetingSkeleton